<script lang="ts">
	import Icon from '$lib/components/Icon/Icon.svelte';
	export let errors: string[] = [];
</script>

{#each errors as error}
	<div class="error">
		<div>
			<Icon icon="warning" size={'18'} color="rgb(208, 2, 27)" />
		</div>
		<div class="error-message">
			<span>{error}</span>
		</div>
	</div>
{/each}

<style>
	.error {
		display: flex;
		inline-size: 100%;
		margin-block: 10px;
		margin-inline: 0;
		padding: 10px;
		border: 1px solid var(--RED);
		border-radius: 3px;
		background-color: var(--LIGHT_RED);
		color: var(--RED);
	}

	.error-message {
		display: flex;
		align-items: center;
		padding-block: 0;
		padding-inline: 10px;
		font-size: var(--fontSizeSmallest);
	}
</style>
